import BackgroundVideo from '../../../resources/scripts/helpers/background-video';
import runH1FadeIn from './h1FadeIn';

class BrixHero {
  static init(...parameters) {
    return new BrixHero(...parameters);
  }

  constructor(block) {
    if (block) {
      const backgroundVideoWrapper = document.querySelector(`#${block.id} > .background > .video`);

      if (backgroundVideoWrapper) {
        BackgroundVideo.init(block);
      }

      // Content slide in animation
      if (block.classList.contains('slideInContent')) {
        const blockContent = block.querySelector('.content').childNodes;
        const contentArray = [...blockContent];
        // eslint-disable-next-line no-plusplus
        for (let i = 0; i < contentArray.length; i++) {
          const child = contentArray[i];
          if (child.nodeType === 1) {
            child.classList.add('animate-me');
            child.classList.add('slideInBottom');
          }
        }
      }

      // H1 typewriter fade in animation
      if (block.classList.contains('fadeInCharacters')) {
        const heroHeading = block.querySelector('h1');
        const heroButton = block.querySelector('.content > .button');
        if (heroHeading) {
          heroHeading.style.opacity = 0;
          heroHeading.style.width = '100%';
          heroHeading.style.opacity = 1;
          runH1FadeIn(heroHeading);
        }
        if (heroButton) {
          heroButton.style.opacity = 0;
        }
      }

      // Background image parallax
      if (block.classList.contains('-fixed-bg-image')) {
        const heroBg = block.querySelector('.background');
        const heroBgImage = heroBg.querySelector('.image');
        heroBg.classList.add('fixed-bg');
        heroBg.style.backgroundImage = `url(${heroBgImage.src})`;
      }

      // Scroll indicator
      const scrollIndictator = document.querySelector(`#${block.id} .scroll-indicator-wrapper`);
      if (scrollIndictator) {
        if (document.body.classList.contains('-theme-dark')) {
          scrollIndictator.classList.add('-theme-dark');
        }

        // Reveal indicator after 3s
        scrollIndictator.style.opacity = 0;
        setTimeout(() => { scrollIndictator.style.opacity = 0.9; }, 3000);

        scrollIndictator.addEventListener('click', (e) => {
          const bottomPos = scrollIndictator.parentNode.getBoundingClientRect().bottom;
          window.scrollTo({
            top: window.innerWidth < 768 ? bottomPos - 72 : bottomPos,
            left: 0,
            behavior: 'smooth',
          });
          e.preventDefault();
        });

        window.addEventListener('scroll', () => {
          if (window.scrollY > 10) {
            scrollIndictator.style.opacity = 0;
            scrollIndictator.style.pointerEvents = 'none';
          } else {
            scrollIndictator.style.opacity = 1;
            scrollIndictator.style.pointerEvents = 'auto';
          }
        });

        window.addEventListener('load', () => {
          if (block) {
            const { height, top } = block.getBoundingClientRect();
            if (height >= window.innerHeight && top === 0) {
              scrollIndictator.classList.remove('-hidden');
            } else {
              scrollIndictator.classList.add('-hidden');
            }
          }
        });

        window.addEventListener('resize', () => {
          if (block) {
            const { height, top } = block.getBoundingClientRect();
            if (height >= window.innerHeight && top === 0) {
              scrollIndictator.classList.remove('-hidden');
            } else {
              scrollIndictator.classList.add('-hidden');
            }
          }
        });
      }
    }
  }
}

// Register class
if (window.brix && window.brix.registerBlock) {
  window.brix.registerBlock('brix-hero', BrixHero.init);
}
